// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605151104/js/" + chunkId + "." + {"44":"a318a1af","225":"8e45177a","481":"9f1021e3","486":"b60346e5","770":"850467f6"}[chunkId] + ".0.5085194424653772.chunk.js";
};